(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wek-b2b-cart"]) return;
  try {
    
document.addEventListener('submit', event => {
  const form = event.target;
  if (form.id !== 'wek-native-cart-form' || event.submitter?.name !== 'checkout') return;
  const changed = [...form.querySelectorAll('[name="updates[]"]')].some(input => input.value !== input.defaultValue);
  if (changed) {
    event.preventDefault();
    form.querySelector('[data-wek-update-first]').hidden = false;
    form.querySelector('[name="update"]').focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wek-journey"]) return;
  try {
    

function initWek(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 if(['evaluate','order'].includes(root.dataset.mode)){
  const showSearchTarget=target=>{if(!target)return;target.scrollIntoView({block:'start',behavior:'instant'});const focus=target.querySelector('input[type="search"],button,h2');if(focus){if(focus.tagName==='H2')focus.tabIndex=-1;focus.focus({preventScroll:true});}};
  root.querySelectorAll('.wm-discovery-top a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
   if(event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
   const id=link.getAttribute('href').slice(1),target=root.querySelector('#'+id);if(!target)return;
   event.preventDefault();
   if(id==='wm-plant-parts'){target.hidden=false;link.setAttribute('aria-expanded','true');}
   if(id==='wm-product-search')target.style.display='flex';
   if(id==='wm-product-search')target.querySelector('input[type="search"]')?.focus({preventScroll:true});
  }));
  root.querySelectorAll('form[action]').forEach(form=>{if(new URL(form.action,location.origin).pathname==='/search'){const url=new URL(form.action,location.origin);url.hash='wek-product-catalog';form.action=url.pathname+url.search+url.hash;}});
  const results=root.querySelector('#wek-product-catalog');
  if(results&&(location.pathname==='/search'||location.hash==='#wek-product-catalog'))requestAnimationFrame(()=>showSearchTarget(results));
 }

 if(['evaluate','order'].includes(root.dataset.mode)){
  const focusProduct=root.querySelector('[data-wek-product-focus]');
  const wireSelections=()=>root.querySelectorAll('a[href]').forEach(link=>{
   if((link.getAttribute('href')||'').startsWith('#'))return;
   const url=new URL(link.href,location.origin);
   if(url.origin!==location.origin||!url.pathname.includes('/products/')||!['OLDwek-Evaluate','OLDwek-Order'].includes(url.searchParams.get('view')))return;
   if(url.hash!=='#wek-selected-product'){url.hash='wek-selected-product';link.href=url.pathname+url.search+url.hash;}
   if(link.closest('.wek-catalog-card,[data-wek-function-card],.wm-recommend-grid')&&!link.querySelector('.wm-selection-label')){
    const label=document.createElement('span');label.className='wm-selection-label';label.textContent=root.dataset.selectionLabel;link.append(label);
   }
  });
  wireSelections();
  const selectionObserver=new MutationObserver(wireSelections);selectionObserver.observe(root,{childList:true,subtree:true});
  root.addEventListener('click',event=>{
   const link=event.target.closest('a[href]');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   const url=new URL(link.href,location.origin);
   if(url.hash==='#wek-selected-product'&&url.pathname.includes('/products/')){
    try{sessionStorage.setItem('wek-product-return',JSON.stringify({from:location.href,to:url.pathname,mode:root.dataset.mode}));}catch(error){}
   }
  });
  if(focusProduct){
   const back=focusProduct.querySelector('[data-wek-back-products]');
   try{const saved=JSON.parse(sessionStorage.getItem('wek-product-return'));if(saved&&saved.to===location.pathname&&saved.mode===root.dataset.mode){const url=new URL(saved.from);if(url.origin===location.origin&&url.pathname!==location.pathname){back.href=url.href;back.addEventListener('click',event=>{if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;if(document.referrer&&new URL(document.referrer).pathname===url.pathname){event.preventDefault();history.back();}});}}}catch(error){}

  }
 }

 root.querySelectorAll('[data-wm-quantity-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.closest('.wm-quantity-controls').querySelector('input');const value=Number(input.value)||1;input.value=String(Math.max(Number(input.min)||1,Math.min(Number(input.max)||100,value+Number(button.dataset.wmQuantityStep))));input.dispatchEvent(new Event('change',{bubbles:true}));}));
 const intakeContext=root.querySelector('[data-wek-intake-context]');
 if(intakeContext){const ctx=new URLSearchParams(location.search);const details=['botanical','product','document','lot'].map(key=>ctx.get(key)).filter(Boolean);if(details.length){intakeContext.querySelector('[data-wek-intake-context-value]').textContent=details.join(' — ');intakeContext.hidden=false;}}
 const v=root.querySelector('[data-wek-variant]'),go=root.querySelector('[data-wek-continue]');if(v&&go){const update=()=>{const u=new URL(go.dataset.productUrl,location.origin);u.searchParams.set('variant',v.value);const previewTheme = document.querySelector('script[data-wek-routing]')?.dataset.theme;if(previewTheme){u.searchParams.set('preview_theme_id',previewTheme);}else{u.searchParams.delete('preview_theme_id');}u.searchParams.set('_fd','0');u.searchParams.set('pb','0');go.href=u.pathname+u.search;};v.addEventListener('change',update);update();}
 const context=new URLSearchParams(location.search);
 let botanical=context.get('botanical')||root.dataset.productTitle||'',productHandle=context.get('product')||root.dataset.productHandle||'',documentType=context.get('document')||'',lot=context.get('lot')||'';
 const carry=()=>{root.querySelectorAll('a[href*="view=wek-documentation"],a[href*="view=WEK-Custom-Formulation"]').forEach(a=>{const u=new URL(a.href,location.origin);for(const [k,v] of Object.entries({botanical,product:productHandle,lot})){if(v)u.searchParams.set(k,v);else u.searchParams.delete(k);}if(documentType&&!a.hasAttribute('data-wek-specific-request')&&(u.searchParams.get('view')==='WEK-Custom-Formulation'||!u.searchParams.has('document')))u.searchParams.set('document',documentType);a.href=u.pathname+u.search+u.hash;});};carry();
 const ds=root.querySelector('[data-wek-doc-search]');
 if(ds){
  const norm=x=>String(x||'').trim().toLowerCase(),kindFrom=x=>/coa|analysis/i.test(x)?'coa':/spec/i.test(x)?'spec':'all';
  ds.elements.botanical.value=botanical;ds.elements.lot.value=lot;ds.elements.kind.value=kindFrom(documentType);
  const filter=()=>{
   botanical=ds.elements.botanical.value.trim();lot=ds.elements.lot.value.trim();const kind=ds.elements.kind.value;documentType=kind==='coa'?'COA':kind==='spec'?'Specification':'Documents';
   const words=norm(botanical).split(/\s+/).filter(Boolean);let count=0;
   root.querySelectorAll('[data-wek-document]').forEach(card=>{
    const productMatch=productHandle?card.dataset.product===productHandle:words.every(w=>norm(card.dataset.search).includes(w));
    const lotMatch=card.dataset.kind!=='coa'||(lot&&norm(card.dataset.lot)===norm(lot));
    card.hidden=!(productMatch&&lotMatch&&(kind==='all'||kind===card.dataset.kind));if(!card.hidden)count++;
   });
   root.querySelector('[data-wek-library-empty]').hidden=count>0;
   root.querySelector('[data-wek-library-status]').textContent=count+' '+root.dataset.docCount+(kind!=='spec'&&!lot?' '+root.dataset.docLotNeeded:'');
   const email=root.querySelector('[data-wek-email-request]');email.href='mailto:wholesale@cherylsherbs.com?subject='+encodeURIComponent('Wholesale '+documentType+' request')+'&body='+encodeURIComponent('Product: '+botanical+'\nProduct handle: '+productHandle+'\nBatch / lot: '+lot+'\nDocument: '+documentType+'\n\nPlease provide the matching released document.');
   carry();const url=new URL(location.href);for(const [k,v] of Object.entries({botanical,product:productHandle,lot,document:documentType})){if(v)url.searchParams.set(k,v);else url.searchParams.delete(k);}history.replaceState(null,'',url.pathname+url.search+url.hash);
  };
  ds.addEventListener('submit',e=>{e.preventDefault();filter();root.querySelector('#wek-document-library').scrollIntoView({block:'start'});});
  ds.elements.botanical.addEventListener('input',()=>{productHandle='';filter();});ds.elements.lot.addEventListener('input',filter);ds.elements.kind.addEventListener('change',filter);
  root.querySelectorAll('[data-doc-kind]').forEach(a=>a.addEventListener('click',()=>{ds.elements.kind.value=kindFrom(a.dataset.docKind);filter();}));filter();
 }
 const search=root.querySelector('[data-wek-search]'),catalog=root.querySelector('[data-wek-catalog]');if(search&&catalog){const filter=()=>{const q=search.value.toLowerCase().trim();let count=0;catalog.querySelectorAll('[data-wek-card]').forEach(c=>{c.hidden=!c.dataset.title.toLowerCase().includes(q);if(!c.hidden)count++;});root.querySelector('[data-wek-empty]').hidden=count>0;};search.addEventListener('input',filter);const loadMore=async(a)=>{try{const res=await fetch(a.href,{credentials:'same-origin'});if(!res.ok)throw Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');const next=doc.querySelector('[data-wek-catalog]');if(!next)throw Error();const known=new Set([...catalog.querySelectorAll('a')].map(x=>x.href));next.querySelectorAll('[data-wek-card]').forEach(c=>{if(!known.has(c.querySelector('a').href))catalog.append(c);});const p=root.querySelector('[data-wek-pagination]'),np=doc.querySelector('[data-wek-pagination]');if(np)p.replaceChildren(...np.childNodes);filter();wire();}catch(e){root.querySelector('[data-wek-catalog-status]').textContent=root.dataset.catalogError;}};const wire=()=>{const a=root.querySelector('[data-wek-next]');if(a)a.addEventListener('click',e=>{e.preventDefault();a.setAttribute('aria-busy','true');loadMore(a);},{once:true});};wire();filter();}
}
document.querySelectorAll('[data-wek-root]').forEach(initWek);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wek-root]').forEach(initWek));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wek-order-v2"]) return;
  try {
    
function initWekGallonSearch(root) {
 if(root.dataset.gallonSearchInitialized)return;
 root.dataset.gallonSearchInitialized='true';
 const forms=[...root.querySelectorAll('.wm-header form, #wm-product-search')];
 const results=root.querySelector('[data-wek-gallon-results]');
 if(!results)return;
 const status=results.querySelector('[role="status"]');
 const catalog=results.querySelector('.wek-catalog');
 let loading, cards, sequence=0;
 const load=()=>{
  if(cards)return Promise.resolve(cards);
  if(loading)return loading;
  loading=(async()=>{
   const collected=[], seen=new Set(), pages=new Set();
   let url=new URL(root.dataset.wekGallonCatalog,location.origin);
   while(url){
    if(url.origin!==location.origin||pages.has(url.href))throw new Error('Invalid catalog pagination');
    pages.add(url.href);
    const response=await fetch(url.href,{credentials:'same-origin'});
    if(!response.ok)throw new Error('Catalog unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html');
    const source=doc.querySelector('[data-wek-gallon-source]');
    if(!source)throw new Error('Catalog unavailable');
    source.querySelectorAll('[data-wek-gallon-card]').forEach(card=>{
     if(!seen.has(card.dataset.productId)){seen.add(card.dataset.productId);collected.push(card);}
    });
    const next=source.querySelector('[data-wek-gallon-next]');
    url=next?new URL(next.getAttribute('href'),location.origin):null;
   }
   cards=collected;return cards;
  })().catch(error=>{loading=null;throw error;});
  return loading;
 };
 forms.forEach(form=>form.addEventListener('submit',async event=>{
  event.preventDefault();
  const ticket=++sequence;
  const query=form.querySelector('[name="q"]').value.trim().toLocaleLowerCase();
  forms.forEach(other=>{other.querySelector('[name="q"]').value=query;});
  catalog.replaceChildren();
  if(!query){results.hidden=true;return;}
  results.hidden=false;results.setAttribute('aria-busy','true');
  status.textContent=results.dataset.loading;
  try{
   const all=await load();
   if(ticket!==sequence)return;
   const words=query.split(/\s+/).filter(Boolean);
   const matched=all.filter(card=>words.every(word=>card.dataset.search.toLocaleLowerCase().includes(word)));
   catalog.replaceChildren(...matched.map(card=>{const copy=card.cloneNode(true);const link=copy.querySelector('a');const url=new URL(link.href,location.origin);url.searchParams.set('view','OLDwek-Order');link.href=url.pathname+url.search;return copy;}));
   status.textContent=matched.length?matched.length+' '+results.dataset.matches:results.dataset.empty;
  }catch(error){if(ticket===sequence)status.textContent=root.dataset.catalogError;}
  finally{if(ticket===sequence){results.removeAttribute('aria-busy');results.scrollIntoView({block:'start',behavior:'auto'});}}
 }));
}
document.querySelectorAll('[data-wek-gallon-catalog]').forEach(initWekGallonSearch);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-wek-gallon-catalog]').forEach(initWekGallonSearch));


function initWekOrderHandoff(root){
 root.querySelectorAll('[data-wek-order-handoff]').forEach(link=>{
  const panel=link.closest('.wm-purchase')||link.parentElement;
  const update=()=>{const selected=panel.querySelector('input[type=radio]:checked');if(!selected)return;const url=new URL(link.href,location.origin);url.searchParams.set('variant',selected.value);link.href=url.pathname+url.search;};
  panel.querySelectorAll('input[type=radio]').forEach(input=>input.addEventListener('change',update));update();
 });
}
function initWek(root){
 initWekOrderHandoff(root);
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 root.querySelectorAll('[data-wm-quantity-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.closest('.wm-quantity-controls').querySelector('input');const value=Number(input.value)||1;input.value=String(Math.max(Number(input.min)||1,Math.min(Number(input.max)||100,value+Number(button.dataset.wmQuantityStep))));input.dispatchEvent(new Event('change',{bubbles:true}));}));
 const intakeContext=root.querySelector('[data-wek-intake-context]');
 if(intakeContext){const ctx=new URLSearchParams(location.search);const details=['botanical','product','document','lot'].map(key=>ctx.get(key)).filter(Boolean);if(details.length){intakeContext.querySelector('[data-wek-intake-context-value]').textContent=details.join(' — ');intakeContext.hidden=false;}}
 const v=root.querySelector('[data-wek-variant]'),go=root.querySelector('[data-wek-continue]');if(v&&go){const update=()=>{const u=new URL(go.dataset.productUrl,location.origin);u.searchParams.set('variant',v.value);const previewTheme = document.querySelector('script[data-wek-routing]')?.dataset.theme;if(previewTheme){u.searchParams.set('preview_theme_id',previewTheme);}else{u.searchParams.delete('preview_theme_id');}u.searchParams.set('_fd','0');u.searchParams.set('pb','0');go.href=u.pathname+u.search;};v.addEventListener('change',update);update();}
 const context=new URLSearchParams(location.search);
 let botanical=context.get('botanical')||root.dataset.productTitle||'',productHandle=context.get('product')||root.dataset.productHandle||'',documentType=context.get('document')||'',lot=context.get('lot')||'';
 const carry=()=>{root.querySelectorAll('a[href*="view=wek-documentation"],a[href*="view=WEK-Custom-Formulation"]').forEach(a=>{const u=new URL(a.href,location.origin);for(const [k,v] of Object.entries({botanical,product:productHandle,lot})){if(v)u.searchParams.set(k,v);else u.searchParams.delete(k);}if(documentType&&!a.hasAttribute('data-wek-specific-request')&&(u.searchParams.get('view')==='WEK-Custom-Formulation'||!u.searchParams.has('document')))u.searchParams.set('document',documentType);a.href=u.pathname+u.search+u.hash;});};carry();
 const ds=root.querySelector('[data-wek-doc-search]');
 if(ds){
  const norm=x=>String(x||'').trim().toLowerCase(),kindFrom=x=>/coa|analysis/i.test(x)?'coa':/spec/i.test(x)?'spec':'all';
  ds.elements.botanical.value=botanical;ds.elements.lot.value=lot;ds.elements.kind.value=kindFrom(documentType);
  const filter=()=>{
   botanical=ds.elements.botanical.value.trim();lot=ds.elements.lot.value.trim();const kind=ds.elements.kind.value;documentType=kind==='coa'?'COA':kind==='spec'?'Specification':'Documents';
   const words=norm(botanical).split(/\s+/).filter(Boolean);let count=0;
   root.querySelectorAll('[data-wek-document]').forEach(card=>{
    const productMatch=productHandle?card.dataset.product===productHandle:words.every(w=>norm(card.dataset.search).includes(w));
    const lotMatch=card.dataset.kind!=='coa'||(lot&&norm(card.dataset.lot)===norm(lot));
    card.hidden=!(productMatch&&lotMatch&&(kind==='all'||kind===card.dataset.kind));if(!card.hidden)count++;
   });
   root.querySelector('[data-wek-library-empty]').hidden=count>0;
   root.querySelector('[data-wek-library-status]').textContent=count+' '+root.dataset.docCount+(kind!=='spec'&&!lot?' '+root.dataset.docLotNeeded:'');
   const email=root.querySelector('[data-wek-email-request]');email.href='mailto:wholesale@cherylsherbs.com?subject='+encodeURIComponent('Wholesale '+documentType+' request')+'&body='+encodeURIComponent('Product: '+botanical+'\nProduct handle: '+productHandle+'\nBatch / lot: '+lot+'\nDocument: '+documentType+'\n\nPlease provide the matching released document.');
   carry();const url=new URL(location.href);for(const [k,v] of Object.entries({botanical,product:productHandle,lot,document:documentType})){if(v)url.searchParams.set(k,v);else url.searchParams.delete(k);}history.replaceState(null,'',url.pathname+url.search+url.hash);
  };
  ds.addEventListener('submit',e=>{e.preventDefault();filter();root.querySelector('#wek-document-library').scrollIntoView({block:'start'});});
  ds.elements.botanical.addEventListener('input',()=>{productHandle='';filter();});ds.elements.lot.addEventListener('input',filter);ds.elements.kind.addEventListener('change',filter);
  root.querySelectorAll('[data-doc-kind]').forEach(a=>a.addEventListener('click',()=>{ds.elements.kind.value=kindFrom(a.dataset.docKind);filter();}));filter();
 }
 const search=root.querySelector('[data-wek-search]'),catalog=root.querySelector('[data-wek-catalog]');if(search&&catalog){const filter=()=>{const q=search.value.toLowerCase().trim();let count=0;catalog.querySelectorAll('[data-wek-card]').forEach(c=>{c.hidden=!c.dataset.title.toLowerCase().includes(q);if(!c.hidden)count++;});root.querySelector('[data-wek-empty]').hidden=count>0;};search.addEventListener('input',filter);const loadMore=async(a)=>{try{const res=await fetch(a.href,{credentials:'same-origin'});if(!res.ok)throw Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');const next=doc.querySelector('[data-wek-catalog]');if(!next)throw Error();const known=new Set([...catalog.querySelectorAll('a')].map(x=>x.href));next.querySelectorAll('[data-wek-card]').forEach(c=>{if(!known.has(c.querySelector('a').href))catalog.append(c);});const p=root.querySelector('[data-wek-pagination]'),np=doc.querySelector('[data-wek-pagination]');if(np)p.replaceChildren(...np.childNodes);filter();wire();}catch(e){root.querySelector('[data-wek-catalog-status]').textContent=root.dataset.catalogError;}};const wire=()=>{const a=root.querySelector('[data-wek-next]');if(a)a.addEventListener('click',e=>{e.preventDefault();a.setAttribute('aria-busy','true');loadMore(a);},{once:true});};wire();filter();}
}
document.querySelectorAll('[data-wek-root]').forEach(initWek);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wek-root]').forEach(initWek));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wek-valuate-v2"]) return;
  try {
    

function initWekEvaluateV2(root){
 if(root.dataset.initialized)return;root.dataset.initialized='true';
 root.querySelectorAll('[data-wek-focus-search]').forEach(link=>link.addEventListener('click',()=>{requestAnimationFrame(()=>{const form=root.classList.contains('wm-approved-initial')?root.querySelector('.wm-v2-header-tools form'):root.querySelector('#wm-product-search');if(form){form.classList.add('is-open');const field=form.querySelector('input[type=search]');field.focus();form.scrollIntoView({block:'center',behavior:'auto'});}});}));
 root.querySelectorAll('form[action]').forEach(form=>{if(form.querySelector('input[name=q]'))form.addEventListener('submit',e=>{const q=form.querySelector('input[name=q]');q.value=q.value.trim();if(!q.value){e.preventDefault();q.focus();}});});
 root.querySelectorAll('a[href]').forEach(link=>{const url=new URL(link.href,location.origin);if(url.origin===location.origin&&url.searchParams.get('view')==='OLDwek-Evaluate'){const previewTheme = document.querySelector('script[data-wek-routing]')?.dataset.theme;if(previewTheme){url.searchParams.set('preview_theme_id',previewTheme);}else{url.searchParams.delete('preview_theme_id');}if(url.pathname.includes('/collections/'))url.searchParams.set('sort_by','title-ascending');link.href=url.pathname+url.search+url.hash;}});
 const mobileMenu=root.querySelector('.wm-v2-menu');if(mobileMenu)mobileMenu.addEventListener('keydown',event=>{if(event.key==='Escape'){mobileMenu.open=false;mobileMenu.querySelector('summary').focus();}});

 root.querySelectorAll('[data-wm-quantity-step]').forEach(button=>button.addEventListener('click',()=>{const input=button.closest('.wm-quantity-controls').querySelector('input');const value=Number(input.value)||1;input.value=String(Math.max(Number(input.min)||1,Math.min(Number(input.max)||100,value+Number(button.dataset.wmQuantityStep))));input.dispatchEvent(new Event('change',{bubbles:true}));}));
 const intakeContext=root.querySelector('[data-wek-intake-context]');
 if(intakeContext){const ctx=new URLSearchParams(location.search);const details=['botanical','product','document','lot'].map(key=>ctx.get(key)).filter(Boolean);if(details.length){intakeContext.querySelector('[data-wek-intake-context-value]').textContent=details.join(' — ');intakeContext.hidden=false;}}
 const v=root.querySelector('[data-wek-variant]'),go=root.querySelector('[data-wek-continue]');if(v&&go){const update=()=>{const u=new URL(go.dataset.productUrl,location.origin);u.searchParams.set('variant',v.value);const previewTheme = document.querySelector('script[data-wek-routing]')?.dataset.theme;if(previewTheme){u.searchParams.set('preview_theme_id',previewTheme);}else{u.searchParams.delete('preview_theme_id');}u.searchParams.set('_fd','0');u.searchParams.set('pb','0');go.href=u.pathname+u.search;};v.addEventListener('change',update);update();}
 const context=new URLSearchParams(location.search);
 let botanical=context.get('botanical')||root.dataset.productTitle||'',productHandle=context.get('product')||root.dataset.productHandle||'',documentType=context.get('document')||'',lot=context.get('lot')||'';
 const carry=()=>{root.querySelectorAll('a[href*="view=wek-documentation"],a[href*="view=WEK-Custom-Formulation"]').forEach(a=>{const u=new URL(a.href,location.origin);for(const [k,v] of Object.entries({botanical,product:productHandle,lot})){if(v)u.searchParams.set(k,v);else u.searchParams.delete(k);}if(documentType&&!a.hasAttribute('data-wek-specific-request')&&(u.searchParams.get('view')==='WEK-Custom-Formulation'||!u.searchParams.has('document')))u.searchParams.set('document',documentType);a.href=u.pathname+u.search+u.hash;});};carry();
 const ds=root.querySelector('[data-wek-doc-search]');
 if(ds){
  const norm=x=>String(x||'').trim().toLowerCase(),kindFrom=x=>/coa|analysis/i.test(x)?'coa':/spec/i.test(x)?'spec':'all';
  ds.elements.botanical.value=botanical;ds.elements.lot.value=lot;ds.elements.kind.value=kindFrom(documentType);
  const filter=()=>{
   botanical=ds.elements.botanical.value.trim();lot=ds.elements.lot.value.trim();const kind=ds.elements.kind.value;documentType=kind==='coa'?'COA':kind==='spec'?'Specification':'Documents';
   const words=norm(botanical).split(/\s+/).filter(Boolean);let count=0;
   root.querySelectorAll('[data-wek-document]').forEach(card=>{
    const productMatch=productHandle?card.dataset.product===productHandle:words.every(w=>norm(card.dataset.search).includes(w));
    const lotMatch=card.dataset.kind!=='coa'||(lot&&norm(card.dataset.lot)===norm(lot));
    card.hidden=!(productMatch&&lotMatch&&(kind==='all'||kind===card.dataset.kind));if(!card.hidden)count++;
   });
   root.querySelector('[data-wek-library-empty]').hidden=count>0;
   root.querySelector('[data-wek-library-status]').textContent=count+' '+root.dataset.docCount+(kind!=='spec'&&!lot?' '+root.dataset.docLotNeeded:'');
   const email=root.querySelector('[data-wek-email-request]');email.href='mailto:wholesale@cherylsherbs.com?subject='+encodeURIComponent('Wholesale '+documentType+' request')+'&body='+encodeURIComponent('Product: '+botanical+'\nProduct handle: '+productHandle+'\nBatch / lot: '+lot+'\nDocument: '+documentType+'\n\nPlease provide the matching released document.');
   carry();const url=new URL(location.href);for(const [k,v] of Object.entries({botanical,product:productHandle,lot,document:documentType})){if(v)url.searchParams.set(k,v);else url.searchParams.delete(k);}history.replaceState(null,'',url.pathname+url.search+url.hash);
  };
  ds.addEventListener('submit',e=>{e.preventDefault();filter();root.querySelector('#wek-document-library').scrollIntoView({block:'start'});});
  ds.elements.botanical.addEventListener('input',()=>{productHandle='';filter();});ds.elements.lot.addEventListener('input',filter);ds.elements.kind.addEventListener('change',filter);
  root.querySelectorAll('[data-doc-kind]').forEach(a=>a.addEventListener('click',()=>{ds.elements.kind.value=kindFrom(a.dataset.docKind);filter();}));filter();
 }
 const search=root.querySelector('[data-wek-search]'),catalog=root.querySelector('[data-wek-catalog]');if(search&&catalog){const filter=()=>{const q=search.value.toLowerCase().trim();let count=0;catalog.querySelectorAll('[data-wek-card]').forEach(c=>{c.hidden=!c.dataset.title.toLowerCase().includes(q);if(!c.hidden)count++;});root.querySelector('[data-wek-empty]').hidden=count>0;};search.addEventListener('input',filter);const loadMore=async(a)=>{try{const res=await fetch(a.href,{credentials:'same-origin'});if(!res.ok)throw Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');const next=doc.querySelector('[data-wek-catalog]');if(!next)throw Error();const known=new Set([...catalog.querySelectorAll('a')].map(x=>x.href));next.querySelectorAll('[data-wek-card]').forEach(c=>{if(!known.has(c.querySelector('a').href))catalog.append(c);});const p=root.querySelector('[data-wek-pagination]'),np=doc.querySelector('[data-wek-pagination]');if(np)p.replaceChildren(...np.childNodes);filter();wire();}catch(e){root.querySelector('[data-wek-catalog-status]').textContent=root.dataset.catalogError;}};const wire=()=>{const a=root.querySelector('[data-wek-next]');if(a)a.addEventListener('click',e=>{e.preventDefault();a.setAttribute('aria-busy','true');loadMore(a);},{once:true});};wire();filter();}
}
document.querySelectorAll('[data-wek-v2-root]').forEach(initWekEvaluateV2);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-wek-v2-root]').forEach(initWekEvaluateV2));


  } catch(e) { console.error(e); }
})();
})();
